import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'shared/ui/tabs';
import { GithubIcon } from 'shared/assets';
import { FolderClosed, Info } from 'lucide-react';
import { Alert, AlertDescription } from 'shared/ui/alert';
import RepoInfo from '@/_pages/application-repo/ui/repo-info';
import { UploadFilesFields } from 'features/upload-files/ui/upload-files-fields';
import { useQuery } from '@tanstack/react-query';
import { singleProject } from '@/enteties/project/api';
import BlurLoading from 'shared/ui/blur-loading';
import * as m from '@paraglide/messages';
import { Link } from '@/shared/ui/link';
import { DOCS_DOMAIN } from '@/shared/lib/util';
export interface StepperProps {
  next: () => void;
}
export const UploadComponent = ({
  next
}: StepperProps) => {
  const {
    projectSlug,
    serviceType,
    uploadType,
    setUploadType
  } = useServiceType();
  const projectQuery = useQuery({
    ...singleProject.getSingleProjectQueryOptions({
      slug: projectSlug
    }),
    enabled: serviceType === 'app',
    retryDelay: 1000,
    retry: 5
  });
  if (projectQuery.isFetching) return <div className="relative h-48">
        <BlurLoading loading />
      </div>;
  if (projectQuery.error) return <div className="h-48 flex items-center justify-center">
        <p className="text-title2">{m.api_error_somethingWentWrong()}</p>
      </div>;
  if (serviceType === 'db' || serviceType === 'marketplace') {
    next();
  }
  return <div className="mt-4 w-full" data-sentry-component="UploadComponent" data-sentry-source-file="upload-component.tsx">
      {/* @ts-ignore */}
      <Tabs defaultValue={uploadType} onValueChange={setUploadType} data-sentry-element="Tabs" data-sentry-source-file="upload-component.tsx">
        <TabsList className="w-full [&>*]:w-full" data-sentry-element="TabsList" data-sentry-source-file="upload-component.tsx">
          <TabsTrigger value="github" data-sentry-element="TabsTrigger" data-sentry-source-file="upload-component.tsx">
            <div className="flex space-x-2">
              <GithubIcon className="size-4" data-sentry-element="GithubIcon" data-sentry-source-file="upload-component.tsx" />
              <span>{m.create_dialog_step_upload_gitOption()}</span>
            </div>
          </TabsTrigger>
          <TabsTrigger value="interface" data-sentry-element="TabsTrigger" data-sentry-source-file="upload-component.tsx">
            <div className="flex space-x-1.5 items-center">
              <FolderClosed className="size-5 p-0.5" data-sentry-element="FolderClosed" data-sentry-source-file="upload-component.tsx" />
              <span>{m.create_dialog_step_upload_interfaceOption()}</span>
            </div>
          </TabsTrigger>
        </TabsList>
        <TabsContent value="github" data-sentry-element="TabsContent" data-sentry-source-file="upload-component.tsx">
          <div className="pt-6 pb-2 space-y-6 w-full">
            <Alert size="sm" variant="info" data-sentry-element="Alert" data-sentry-source-file="upload-component.tsx">
              <Info className="size-5 p-0.5" data-sentry-element="Info" data-sentry-source-file="upload-component.tsx" />
              <AlertDescription data-sentry-element="AlertDescription" data-sentry-source-file="upload-component.tsx">
                {m.create_dialog_step_upload_gitOption_hint()}
              </AlertDescription>
            </Alert>
            <RepoInfo slug={projectSlug} listVariant="no-disc" data-sentry-element="RepoInfo" data-sentry-source-file="upload-component.tsx" />
          </div>
        </TabsContent>
        <TabsContent value="interface" data-sentry-element="TabsContent" data-sentry-source-file="upload-component.tsx">
          <div className="pt-6 pb-2 space-y-6 w-full">
            <Alert size="sm" variant="info" data-sentry-element="Alert" data-sentry-source-file="upload-component.tsx">
              <Info className="size-5 p-0.5" data-sentry-element="Info" data-sentry-source-file="upload-component.tsx" />
              <AlertDescription data-sentry-element="AlertDescription" data-sentry-source-file="upload-component.tsx">
                {m.create_dialog_step_upload_interfaceOption_hint_start()}
                <Link href={`${DOCS_DOMAIN}/applications/environments/python-pip.html#requirements-txt`} className="[&>div]:inline text-link underline" data-sentry-element="Link" data-sentry-source-file="upload-component.tsx">
                  {m.create_dialog_step_upload_interfaceOption_hint_link()}
                </Link>
                {m.create_dialog_step_upload_interfaceOption_hint_end()}
              </AlertDescription>
            </Alert>
            <UploadFilesFields tab="CODE" path="/" slug={projectSlug} data-sentry-element="UploadFilesFields" data-sentry-source-file="upload-component.tsx" />
          </div>
        </TabsContent>
      </Tabs>
    </div>;
};